import { callAPI, HTTPMethod, getAuthenticatedGetUrl } from "./API";
import { Cfdis, Cfdi, CfdiQueryParams, CfdisExportResponse, ReplacePaymentCfdiRequest, CancelCfdiRequest } from "../model/Cfdi";

const getBaseApi = (tenantId: string) => {
    return `/tenants/${tenantId}/cfdis`;
};

const getQuery = (params: CfdiQueryParams, page: number, offset: number) => {
    const query = {
        search: params.search,
        type: params.type,
        from: params.from || "",
        to: params.to || "",
        pageSize: page.toString(),
        offset: offset.toString(),
    } as any;

    if (params.payment_status) {
        query["paymentStatus"] = params.payment_status;
    }

    if (params.ids) {
        query["ids"] = params.ids;
    }

    if (params.from) {
        query["from"] = params.from;
    }

    if (params.to) {
        query["to"] = params.to;
    }

    return query;
};

export async function getCfdis(tenantId: string, page: number, offset: number, params: CfdiQueryParams): Promise<Cfdis> {
    return await callAPI(getBaseApi(tenantId), {
        method: HTTPMethod.GET,
        query: getQuery(params, page, offset)
    });
}

export async function exportCfdis(tenantId: string, params: CfdiQueryParams): Promise<CfdisExportResponse> {
    return await callAPI(`${getBaseApi(tenantId)}/export`, {
        method: HTTPMethod.GET,
        query: getQuery(params, 0, 0)
    });
}

export async function downloadCfdis(tenantId: string, params: CfdiQueryParams): Promise<CfdisExportResponse> {
    return await callAPI(`${getBaseApi(tenantId)}/download`, {
        method: HTTPMethod.GET,
        query: getQuery(params, 0, 0)
    });
}

export async function getCfdi(tenantId: string, cfdiId: string): Promise<Cfdi> {
    return await callAPI(`${getBaseApi(tenantId)}/${cfdiId}`, {
        method: HTTPMethod.GET,
    });
}

export async function cancelCfdi(tenantId: string, cfdiId: string, request: CancelCfdiRequest): Promise<Cfdi> {
    return await callAPI(`${getBaseApi(tenantId)}/${cfdiId}/cancel`, {
        method: HTTPMethod.PUT,
        body: request,
    });
}

export async function replaceCfdi(tenantId: string, cfdiId: string, request: ReplacePaymentCfdiRequest): Promise<Cfdi> {
    return await callAPI(`${getBaseApi(tenantId)}/${cfdiId}/replace`, {
        method: HTTPMethod.PUT,
        body: request
    });
}

export async function getCfdiXml(tenantId: string, cfdiId: string): Promise<string> {
    return getAuthenticatedGetUrl(`${getBaseApi(tenantId)}/${cfdiId}/xml`);
}

export async function getCfdiPdf(tenantId: string, cfdiId: string): Promise<string> {
    return getAuthenticatedGetUrl(`${getBaseApi(tenantId)}/${cfdiId}/pdf`);
}

export async function markAsPaid(tenantId: string, cfdiId: string): Promise<Cfdi> {
    return await callAPI(`${getBaseApi(tenantId)}/${cfdiId}/paid`, {
        method: HTTPMethod.PUT,
    });
}
